import { css, Global } from '@emotion/react';
import { a34, a34Mq, auction34RootVars } from '@/components/Auction34/tokens';

/**
 * 맨션상점 전용 전역 스타일.
 * 이 컴포넌트가 마운트된 동안에만 토큰(:root 변수)과 페이지 리셋이 적용됩니다.
 * 앱 공통 GlobalStyles 뒤에 삽입되므로 html/body 지정을 덮어씁니다.
 */
const auction34GlobalStyles = css`
  :root {
    ${auction34RootVars}
  }

  ${a34Mq.mobile} {
    :root {
      /* 모바일 좌우 여백 */
      --shell-pad-x: 14px;
    }
  }

  html,
  body {
    margin: 0;
    padding: 0;
    background: ${a34.color.bg};
    color: ${a34.color.text};
    font-family: ${a34.font.kr};
    /* 앱 공통 GlobalStyles 의 line-height:1.5 를 되돌려 목업 기준(normal)에 맞춥니다. */
    line-height: normal;
    -webkit-font-smoothing: antialiased;
  }

  button {
    font-family: inherit;
  }
`;

const Auction34GlobalStyles = () => <Global styles={auction34GlobalStyles} />;

export default Auction34GlobalStyles;
